import React, { useEffect, useRef } from "react";
import { X } from "lucide-react";

export default function VideoModal({ open, onClose, src }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
      const t = setTimeout(() => {
        videoRef.current?.play().catch(() => {});
      }, 80);
      const onKey = (e) => e.key === "Escape" && onClose();
      window.addEventListener("keydown", onKey);
      return () => {
        clearTimeout(t);
        window.removeEventListener("keydown", onKey);
        document.body.style.overflow = "";
        if (videoRef.current) {
          try {
            videoRef.current.pause();
            videoRef.current.currentTime = 0;
          } catch (_) {}
        }
      };
    }
    document.body.style.overflow = "";
    return undefined;
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      data-testid="video-modal"
      role="dialog"
      aria-modal="true"
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 md:p-10"
    >
      {/* Backdrop */}
      <button
        data-testid="video-modal-backdrop"
        aria-label="Close video"
        onClick={onClose}
        className="absolute inset-0 bg-[#050505]/85 backdrop-blur-md cursor-default"
      />

      {/* Close */}
      <button
        data-testid="video-modal-close"
        onClick={onClose}
        aria-label="Close video"
        className="absolute top-6 right-6 md:top-8 md:right-8 w-11 h-11 rounded-full border border-[#C5A059]/40 hover:border-[#C5A059] hover:bg-[#C5A059] hover:text-black text-[#C5A059] flex items-center justify-center transition-all z-10"
      >
        <X className="w-4 h-4" />
      </button>

      {/* Player */}
      <div className="relative z-[101] w-full max-w-5xl aspect-video bg-black border border-[#C5A059]/30 shadow-[0_30px_120px_-20px_rgba(197,160,89,0.35)]">
        <video
          ref={videoRef}
          data-testid="video-modal-video"
          src={src}
          controls
          playsInline
          className="w-full h-full object-contain bg-black"
        />
      </div>
    </div>
  );
}
